import { render, staticRenderFns } from "./bucket-tree-view.html?vue&type=template&id=1c36c53a&scoped=true&"
import script from "./bucket-tree-view.js?vue&type=script&lang=js&"
export * from "./bucket-tree-view.js?vue&type=script&lang=js&"
import style0 from "./bucket-tree-view.scss?vue&type=style&index=0&id=1c36c53a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c36c53a",
  null
  
)

export default component.exports